// removed by extract-text-webpack-plugin
module.exports = {"searchIcon":"searchIcon--91327"};